import {mapActions, mapGetters, mapMutations} from "vuex";
import productCard from '@/components/product-card/index.vue'
import productSlider from "@/components/slider/index.vue";

export default {
    name: "product",
    components: {
        productSlider,
        productCard
    },
    props: {
        item: {
            type: String,
            default: () => {
            }
        },
    },
    data() {
        return {}
    },
    created() {

    },
    computed: {
        ...mapGetters({
            latestProducts: 'home/productData'
        })
    },

    methods: {
        ...mapMutations({}),
        ...mapActions({
            fetchLatestProducts: 'home/LATEST_PRODUCTS'
        })
    }

}
